import {
  Component, Input, ElementRef, ViewChild, ContentChildren, QueryList,
} from '@angular/core';
import * as _ from 'lodash';

import { ScorecardItemComponent } from 'shared/scorecard/scorecard-item/scorecard-item.component';


@Component({
  moduleId: module.id,
  selector: 'scorecard-component',
  templateUrl: 'scorecard.component.html',
  styleUrls: ['scorecard.component.scss'],
})
export class ScorecardComponent {
  @Input() title: string;

  @ViewChild('scroll', {static: false})
  scroll: ElementRef | void;

  @ContentChildren(ScorecardItemComponent)
  scorecardElements: QueryList<ElementRef>;

  private threeElementsHeight: number = 123;
  private scorecardItemHeight: number = 41;

  get scrollEl(): any {
    return _.get(this.scroll, 'nativeElement');
  }

  /*******************************************
  * COMPONENT PUBLIC API
  *******************************************/

  scrollToScorecardItem(scorecardItem: ScorecardItemComponent) {
    if (!scorecardItem) { return; }
    if (!this.isScorecardItemInView(scorecardItem) && this.scroll) {
      this.scroll.nativeElement.scrollTop = scorecardItem.offsetTop - 5;
    }
  }

  private isScorecardItemInView(scorecardItem: ScorecardItemComponent) {
    const scrollTop = this.scrollEl.scrollTop;
    const scrollBottom = scrollTop + this.scrollEl.offsetHeight;
    const elementTop = scorecardItem.offsetTop;
    const elementBottom = elementTop + scorecardItem.offsetHeight;
    return ((scrollTop < elementTop) && (scrollBottom > elementBottom));
  }
}
